import overview from "./overview.json";
import concepts from "./concepts.json";
import quickStart from "./quick-start.json";
import projects from "./projects.json";
import teamManagement from "./team-management.json";
import testCases from "./test-cases.json";
import testGroups from "./test-groups.json";
import aiGenerator from "./ai-generator.json";
import variablesEnvironments from "./variables-environments.json";
import fileManager from "./file-manager.json";
import automationStudio from "./automation-studio.json";
import testLaunches from "./test-launches.json";
import testRuns from "./test-runs.json";
import appIntegrations from "./app-integrations.json";
import cicdPipelines from "./cicd-pipelines.json";
import mcpOverview from "./mcp-overview.json";
import mcpSetup from "./mcp-setup.json";
import mcpTools from "./mcp-tools.json";
import usersRoles from "./users-roles.json";
import aiModels from "./ai-models.json";
import aiCostTracking from "./ai-cost-tracking.json";
import organizations from "./organizations.json";
import apiAuth from "./api-auth.json";
import apiEndpoints from "./api-endpoints.json";
import faq from "./faq.json";
import signup from "./signup.json";
import orgProject from "./org-project.json";
import testCasesModules from "./test-cases-modules.json";
import testRunsExecution from "./test-runs-execution.json";
import automationStudioGuide from "./automation-studio-guide.json";
import executionPlan from "./execution-plan.json";
import launchMonitoring from "./launch-monitoring.json";
import resultsAnalytics from "./results-analytics.json";

const SECTION_CONFIG_BY_ID = {
  overview,
  concepts,
  "quick-start": quickStart,
  projects,
  team: teamManagement,
  "test-cases": testCases,
  "test-groups": testGroups,
  "ai-generator": aiGenerator,
  variables: variablesEnvironments,
  "file-manager": fileManager,
  "automation-studio": automationStudio,
  "test-launches": testLaunches,
  "test-runs": testRuns,
  "app-integrations": appIntegrations,
  cicd: cicdPipelines,
  "mcp-overview": mcpOverview,
  "mcp-setup": mcpSetup,
  "mcp-tools": mcpTools,
  "users-roles": usersRoles,
  "ai-models": aiModels,
  "ai-cost": aiCostTracking,
  organizations,
  auth: apiAuth,
  endpoints: apiEndpoints,
  faq,
  "gs-signup": signup,
  "gs-org-project": orgProject,
  "gs-test-cases": testCasesModules,
  "gs-test-runs": testRunsExecution,
  "gs-automation": automationStudioGuide,
  "gs-exec-plan": executionPlan,
  "gs-launch": launchMonitoring,
  "gs-results": resultsAnalytics,
};

export function getSectionConfig(sectionId) {
  return SECTION_CONFIG_BY_ID[sectionId] ?? null;
}

export function hasSectionConfig(sectionId) {
  return sectionId in SECTION_CONFIG_BY_ID;
}
